import { cn as e } from "../../shared/utils.js";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
import { cva as r } from "class-variance-authority";
import { Checkbox as i } from "@base-ui/react";
//#region src/checkbox/primitive/index.tsx
var a = r(["transition-base border-control-border bg-control-bg text-icon-on flex shrink-0 items-center justify-center border-2 transition-[background-color,border-color,box-shadow] outline-none"], {
	defaultVariants: {
		interactive: !0,
		size: "md"
	},
	variants: {
		checked: { true: "border-control-active bg-control-active" },
		interactive: {
			false: "",
			true: [
				"hover:border-control-border-hover",
				"focus-visible:border-control-border-hover focus-visible:shadow-[0_0_4px_2px_var(--color-alpha-gray-alpha-gray-5),0_0_0_4px_var(--color-alpha-primary-20)]",
				"data-checked:border-control-active data-checked:bg-control-active",
				"data-checked:hover:border-control-active-hover data-checked:hover:bg-control-active-hover",
				"data-disabled:border-control-border-disabled data-disabled:bg-control-bg data-disabled:cursor-not-allowed",
				"data-disabled:data-checked:border-control-active-disabled data-disabled:data-checked:bg-control-active-disabled"
			]
		},
		size: {
			sm: "size-4 rounded-[3.44px]",
			md: "rounded-sm size-5",
			lg: "rounded-sm size-6"
		}
	}
}), o = r(["transition-base flex items-center justify-center transition-[opacity,transform] [&>svg:not([class*=size-])]:size-full", "data-checked:scale-100 data-checked:opacity-100 data-unchecked:scale-0 data-unchecked:opacity-0"], {
	defaultVariants: { size: "md" },
	variants: { size: {
		sm: "size-3.5",
		md: "size-4",
		lg: "size-4"
	} }
}), s = t(({ className: t, size: r = "md", ...o }, s) => /* @__PURE__ */ n(i.Root, {
	ref: s,
	className: e(a({ size: r }), t),
	...o
})), c = t(({ children: t, className: r, keepMounted: a = !0, size: s = "md", ...c }, u) => /* @__PURE__ */ n(i.Indicator, {
	ref: u,
	keepMounted: a,
	className: e(o({ size: s }), r),
	...c,
	children: t ?? /* @__PURE__ */ n(l, {})
}));
function l() {
	return /* @__PURE__ */ n("svg", {
		"aria-hidden": !0,
		className: "size-full",
		fill: "none",
		viewBox: "0 0 16 16",
		children: /* @__PURE__ */ n("path", {
			d: "M3.333 8.333 6.333 11.333 12.667 4.667",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2"
		})
	});
}
s.displayName = i.Root.displayName, c.displayName = i.Indicator.displayName;
var u = {
	Root: s,
	Indicator: c
};
//#endregion
export { u as Checkbox, l as CheckboxCheckIcon, o as checkboxIndicatorVariants, a as checkboxRootVariants };
